import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { UserPlus, Coffee, X } from 'lucide-react';
import { SUPPORT_CONFIG } from '../config/support';

export default function ApplyPublisherModal({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) return;
    document.documentElement.style.overflow = 'hidden';
    return () => { document.documentElement.style.overflow = ''; };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const handle = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handle);
    return () => document.removeEventListener('keydown', handle);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[70] backdrop-blur-sm bg-black/40 flex items-center justify-center p-4 animate-fadeOnly"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-white rounded-2xl max-w-sm w-full shadow-2xl border border-slate-200 p-6 animate-slideUp">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-start gap-3">
            <div className="text-purple-500 mt-0.5 flex-shrink-0">
              <UserPlus size={22} />
            </div>
            <div>
              <h3 className="text-base font-semibold text-slate-900 mb-1">Become a Publisher</h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                Share your palettes with the MarkerSync community in the public gallery.
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors flex-shrink-0 -mt-1 -mr-1"
          >
            <X size={16} />
          </button>
        </div>

        <ul className="text-sm text-slate-600 space-y-2 mb-5 ml-9">
          <li>• Publishers can make palettes visible in the public gallery</li>
          <li>• Publisher status is granted manually after a quick review</li>
          <li>• Just send us an email and we'll get back to you</li>
        </ul>

        <div className="flex flex-col gap-2">
          <a
            href="mailto:markersync@gmail.com?subject=Publisher%20Application%20%E2%80%94%20MarkerSync%20Gallery"
            onClick={onClose}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 rounded-xl transition-colors"
          >
            Apply Now
          </a>
          <a
            href={SUPPORT_CONFIG.platforms.buyMeACoffee.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-xs font-medium text-yellow-700 bg-yellow-50 hover:bg-yellow-100 border border-yellow-200 rounded-xl transition-colors"
          >
            <Coffee size={13} />
            Support the project
          </a>
          <button
            onClick={onClose}
            className="w-full px-4 py-2 text-xs font-medium text-slate-400 hover:text-slate-600 transition-colors"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
